import request from '../../axios';

const getRange = async ({inputGroupGuid}: {inputGroupGuid?: string}) => {
  const {data}: {data: IRange} = await request.get(
    `api/v2/store/ads-price-range?input_group_guid=${inputGroupGuid}`,
  );
  return data;
};

export default getRange;
